import { TIPO_EMPRESA } from './Models'

export const checkTipoEmpresas = (
  permissoesNecessarias: TIPO_EMPRESA[],
  permissoes: TIPO_EMPRESA[]
) => {
  return permissoesNecessarias.some((p) => permissoes?.includes(p))
}
